'use strict';

module.exports = [['&', ' and '], ['🦄', ' unicorn '], ['♥', ' love ']];